import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/fibonacci-calculator',
  component: () => import('../../routes/FibonacciCalculator.svelte'),
  card: {
    id: 'fibonacci-calculator',
    title: 'Fibonacci Calculator',
    description: 'Calculate the nth Fibonacci number using iterative and Binet\'s formula methods. Shows sequence, golden ratio approximation, and step-by-step breakdown.',
    icon: 'functions',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/fibonacci-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Fibonacci Calculator – Free n-th Number Calculator with Sequence & Golden Ratio',
    description: 'Free Fibonacci calculator. Compute F(n) for any non-negative integer using iterative and Binet\'s formula methods. Shows full sequence, golden ratio approximation, and formula breakdown.',
  },
};

export default meta;